jQuery(document).ready(function($) {

	var Config = {
        Link: "a.share",
        Width: 500,
        Height: 500
    };

    $('.btn-share--linkedin').on('click', function(e){
    	var item = $(this);
        e.preventDefault();

        var link = item.data('link');
        var title = encodeURIComponent(item.data('title'));
        var summary = encodeURIComponent(item.data('share'));
        var popupLink = 'https://www.linkedin.com/shareArticle?mini=true&url='+link+'&title='+title+'&summary='+summary;

        var
            px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
            py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

        var popup = window.open(popupLink, "social", 
            "width="+Config.Width+",height="+Config.Height+
            ",left="+px+",top="+py+
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }

    });

    $('.btn-share--twitter').on('click', function(e){
    	var item = $(this);
        e.preventDefault();
        var link = item.data('link');
        var tweetText = encodeURIComponent(item.data('share'));
        var popupLink = 'https://twitter.com/intent/tweet?url='+link+'&text='+tweetText;

        var
            px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
            py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

        var popup = window.open(popupLink, "social", 
            "width="+Config.Width+",height="+Config.Height+
            ",left="+px+",top="+py+
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }

    });

    $('.btn-share--facebook').on('click', function(e){
    	var item = $(this);
        e.preventDefault();
        var link = item.data('link');
        var popupLink = 'https://www.facebook.com/sharer/sharer.php?u='+link;

        var
            px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
            py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

        var popup = window.open(popupLink, "social", 
            "width="+Config.Width+",height="+Config.Height+
            ",left="+px+",top="+py+
            ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");
        if (popup) {
            popup.focus();
            if (e.preventDefault) e.preventDefault();
            e.returnValue = false;
        }

    });
});